export const getStyles = () => ({
  vanityUrlOption: {
    '& .form-group-subset': {
      paddingLeft: '28px',

      '& .form-control-static': {
        marginTop: '0px',
        minHeight: 'unset',
      },
    },

    '& .website-description-options': {
      display: 'inline-flex',
      flexDirection: 'row',
      gap: '16px',

      '& select.form-control': {
        width: 'fit-content',
        paddingRight: '100px',
      },
    },

    '& .website-description-info': {
      margin: '8px 0 12px 0',
    },

    '& .language-disclaimer': {
      marginTop: '12px',
    },
  },
});
